/*!

=========================================================
* Argon Dashboard PRO React - v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// React
import React, { useEffect } from "react";
import { connect } from 'react-redux';

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardImg,
  CardTitle,
  FormGroup,
  Form,
  Input,
  ListGroupItem,
  ListGroup,
  Progress,
  Container,
  Row,
  Col,
} from "reactstrap";

// Section Imports
import Upload from './Upload';
import Review from './Review';

function Create({ reporting }) {

  console.log("Reporting: ", reporting);

  return (
    {
      'upload': <Upload />,
      'review': <Review />
    }[reporting.process.stage]
  )
}

// Connect to store
const ConnectedCreate = connect(state => ({
  reporting: state.reporting
}))(Create);

export default ConnectedCreate;
